import { useRef, useState } from "react";
import { input } from "@/components/clinic/playerStore";

const R = 52;

export function Joystick() {
  const [knob, setKnob] = useState({ x: 0, y: 0 });
  const origin = useRef(null);
  const update = (e) => {
    if (!origin.current) return;
    let dx = e.clientX - origin.current.x;
    let dy = e.clientY - origin.current.y;
    const d = Math.hypot(dx, dy);
    if (d > R) {
      dx = (dx / d) * R;
      dy = (dy / d) * R;
    }
    setKnob({ x: dx, y: dy });
    input.joy = { x: dx / R, y: dy / R };
  };
  const end = () => {
    origin.current = null;
    setKnob({ x: 0, y: 0 });
    input.joy = { x: 0, y: 0 };
  };
  return (
    <div
      data-testid="virtual-joystick"
      className="glass-dark relative grid h-32 w-32 touch-none select-none place-items-center rounded-full"
      onPointerDown={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        origin.current = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
        e.currentTarget.setPointerCapture(e.pointerId);
        update(e);
      }}
      onPointerMove={update}
      onPointerUp={end}
      onPointerCancel={end}
    >
      <div className="absolute inset-3 rounded-full border border-cyan-300/30" />
      <div
        className="h-12 w-12 rounded-full bg-cyan-400/90 shadow-lg shadow-cyan-400/50"
        style={{ transform: `translate(${knob.x}px, ${knob.y}px)` }}
      />
    </div>
  );
}
